import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Swiper from "swiper/dist/js/swiper.esm.bundle";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";

import Term from "../../shared/term";
import SpinLoading from "../../shared/spin_loading";
import "../../../packs/translations";

const HotelOtherList = props => {
  const [termsList, setTermsList] = useState([]);
  const [isLoad, setIsLoad] = useState(false);

  const loadRecommended = () => {
    axios
      .get(`/api/products/${props.product_id}/recommended`, {
        params: {
          hotel_id: props.hotel_id,
          adults: props.adults,
          children: props.children,
          rooms: props.rooms,
          meal_ids: props.meal_ids
        }
      })
      .then(response => {
        setTermsList(response.data);
        setIsLoad(true);
        new Swiper(".swiper-container--carousel", {
          slidesPerView: 3,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 10
            }
          }
        });
        on_load();
      })
      .catch(error => {
        console.log(error.response);
      });
  };

  return (
    <VisibilitySensor
      scrollCheck={true}
      partialVisibility={true}
      onChange={visible => {
        if (visible && !isLoad) {
          loadRecommended();
        }
      }}
    >
      <section className="offers-list offers-list--light page-hotel--list">
        <div className="container">
          <h2 className="title-h2 text-primary text-center">
            {I18n.t("js.show_tour.recommended")}
          </h2>
          <SpinLoading show={!isLoad} />
          <div className="offers-list__wrap row">
            <div className="swiper-container swiper-container--carousel swiper-container-initialized swiper-container-horizontal">
              <div className="swiper-wrapper">
                {termsList.map(term => (
                  <div className="swiper-slide" key={term.id}>
                    <Term
                      homepage={false}
                      key={term.id}
                      id={term.id}
                      hotel_path={term.hotel_path}
                      hotel_image_url={term.hotel_image_url}
                      hotel_stars={term.hotel_stars}
                      hotel_destination={term.hotel_destination}
                      meals={term.meals}
                      transport={term.transport}
                      label_for_term={term.label_for_term}
                      current_date_start={term.current_date_start}
                      current_date_end={term.current_date_end}
                      days={term.days}
                      extra_info={term.extra_info}
                      price_label={term.price_label}
                      tour_type={term.tour_type}
                      badge_class={term.badge_class}
                    />
                  </div>
                ))}
              </div>
              <div className="swiper-pagination" style={{ bottom: 0 }} />
            </div>
          </div>
        </div>
      </section>
    </VisibilitySensor>
  );
};

HotelOtherList.propTypes = {
  hotel_id: PropTypes.number.isRequired,
  product_id: PropTypes.number.isRequired,
  adults: PropTypes.number.isRequired,
  children: PropTypes.number.isRequired,
  rooms: PropTypes.number
};

export default HotelOtherList;
